// Public-chrome layout snapshot, read from /api/settings/banner for DESIGN-02.
// Existing seo/buildData has no banner field; this records ONLY the published policy,
// not banner copy. The unchanged live banner request reconciles this reservation.
export const PUBLISHED_BANNER_LAYOUT = {
  enabled: true,
  startsOn: '',
  expiresOn: '2026-12-31',
};

export const reservePublishedBanner = () => {
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  return PUBLISHED_BANNER_LAYOUT.enabled && (!PUBLISHED_BANNER_LAYOUT.startsOn || today >= PUBLISHED_BANNER_LAYOUT.startsOn) && today <= PUBLISHED_BANNER_LAYOUT.expiresOn;
};
